import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { AppRoute } from "../App";
import ScreenLoader from "./ui/ScreenLoader";

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const { isAuthenticated } = useAuth();

  if(isAuthenticated === null){
    return <ScreenLoader isLoading={true} />;

  }

  if (isAuthenticated === false) {
    return <Navigate to={AppRoute.Login} replace />;
  }
  return <>{children}</>;
}; 

